export const StatDisplay = (value:number, suffix?: string, showModifier?: boolean): string => {
    if(value >= 0) return `${showModifier ? "+" : ""}${value}${suffix ?? ""}`;
    return value.toString();
}

export const StatDisplayExtra = (value:number,
    options?: {
        suffix?: string,
        showModifier?: boolean
    }
): string => {
    if(value >= 0) return `${options?.showModifier ? "+" : ""}${value}${options?.suffix ?? ""}`;
    return value.toString();
}

export const StrongHitRangeLabel = (value: number) => {
        if((value ?? 0) < 0) return "-";
        return `${6-(value ?? 0)}-6`;
    }